import React from "react";

import { format, getMonth, getYear, subDays, subMonths } from "date-fns";

import TimelineMonth from "./TimelineMonth";

const getCurrentMonth = () => {
  const currentDate = new Date();
  const currentMonth = getMonth(currentDate);
  const currentYear = getYear(currentDate);

  return format(new Date(currentYear, currentMonth), "MM-YYYY");
};

class Timeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      months: [getCurrentMonth()],
    };
  }

  showNextDay = () => {
    this.setState((prevState) => {
      const { days } = prevState;

      const lastDay = days[days.length - 1];
      const lastDayPlusOne = subDays(lastDay, 1);

      return {
        days: [...days, lastDayPlusOne.getTime()],
      };
    });
  };

  showNextMonth = () => {
    this.setState((prevState) => {
      const { months } = prevState;

      const [month, year] = months[months.length - 1].split("-");
      const lastMonthMinusOne = format(
        subMonths(new Date(year, month - 1), 1),
        "MM-YYYY"
      );

      return {
        months: [...months, lastMonthMinusOne],
      };
    });
  };

  render = () => {
    const { months } = this.state;

    return (
      <div className="timeline">
        {months.map((month, index) => (
          <TimelineMonth
            key={`${month}-${index}`}
            month={month}
            allowPolling={index === 0}
          />
        ))}

        <div>
          <button
            className="timeline__btn btn is-outline is-small is-spaced"
            type="button"
            onClick={this.showNextMonth}
          >
            <span className="btn__text">Toon meer</span>
            <svg className="btn__icon is-suffix" width="14px" height="14px">
              <use xlinkHref="#arrow-down" width="14px" height="14px" />
            </svg>
          </button>
        </div>
      </div>
    );
  };
}

export default Timeline;
